import { AlertTriangle } from "lucide-react";
import { Alert, AlertTitle, AlertDescription } from "./ui/alert";

interface BasicAlertProps {
  type: "info" | "warning" | "error" | "success";
  title?: string;
  description?: string;
}

const BasicAlert: React.FC<BasicAlertProps> = ({
  type,
  title,
  description,
}) => {
  return (
    <Alert
      variant={type === "error" ? "destructive" : "default"}
      className={type === "error" ? "border-red-500" : ""}
    >
      <AlertTriangle className="w-6 h-6" />
      {title ? <AlertTitle>{title}</AlertTitle> : null}
      {description && <AlertDescription>{description}</AlertDescription>}
    </Alert>
  );
};

export default BasicAlert;
